<div class="card-container">
  @if (timeOut()) {
    <app-timeout></app-timeout>
  } @else if (loading()) {
    <div class="flex justify-content-center align-items-center">
      <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
    </div>
  } @else {
    @if (config()) {
      <div class="content-container">
        <app-svg-icon
          class="svg"
          [iconName]="config()?.icon?.name"
          [iconColor]="config()?.icon?.color ?? ''"
          iconSize="l"
        ></app-svg-icon>

        <span class="top-row value kpiValue">{{ values()?.[0] }}</span>
        <span class="top-row title kpiLabel">{{ config()?.labels?.[0] ?? "" | translate }}</span>
        <hr />
        <span class="bottom-row value kpiValue">{{ values()?.[1] }}</span>
        <span class="bottom-row title kpiLabel">{{ config()?.labels?.[1] ?? "" | translate }}</span>
      </div>
    }
  }
</div>
